import { getCountryCodeByTz } from '../helpers/timezone'

export const getCookie = (name: string): string | null => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
  ))
  return matches ? decodeURIComponent(matches[1]) : null
}

export const setCookie = (name: string, lifeTimeHours: number = 0): void => {
  const cookieBanner = document.querySelector<HTMLElement>('#cookie')
  if (cookieBanner) {
    cookieBanner.classList.remove('active')
  }

  const now = new Date()
  now.setTime(now.getTime() + lifeTimeHours * 3600 * 1000)

  if (lifeTimeHours > 0) {
    document.cookie = `${name}=accepted; expires=${now.toUTCString()}; path=/;`
  } else {
    document.cookie = `${name}=accepted; path=/;`
  }
}

export const cookiesPopUp = (): void => {
  const cookieBanner = document.querySelector<HTMLElement>('#cookie')
  const showMore = document.querySelector<HTMLElement>('#cookie .show-more')
  const text = document.querySelector<HTMLElement>('#cookie .cookie-text')

  const widthWindow = document.documentElement.clientWidth

  const countryCode = getCountryCodeByTz()

  const countryCodes = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'SK', 'SI', 'ES', 'SE', 'GB']

  let isAllowCookie = false
  if (countryCode) {
    isAllowCookie = countryCodes.includes(countryCode)
  }

  if (widthWindow >= 768) {
    const isAcceptedCookie = getCookie('customCookieAccept')

    if (!isAcceptedCookie && isAllowCookie) {
      setTimeout(() => {
        if (cookieBanner) {
          cookieBanner.classList.add('active')
        }
      }, 2500)
    }
  } else {
    window.addEventListener('scroll', function () {
      if (pageYOffset > 450) {
        const isAcceptedCookie = getCookie('customCookieAccept')
        if (!isAcceptedCookie && isAllowCookie) {
          if (cookieBanner) {
            cookieBanner.classList.add('active')
          }
        }
      }
    })
  }

  if (showMore && text) {
    showMore.onclick = function (this: any) {
      this.style.display = 'none'
      text.style.maxHeight = '300px'
    }
  }

  const accept = document.querySelector<HTMLElement>('#cookie-accept')
  const later = document.querySelector<HTMLElement>('#cookie-later')

  if (accept) {
    accept.addEventListener('click', () => {
      setCookie('customCookieAccept', 24 * 30 * 6)
    })
  }

  if (later) {
    later.addEventListener('click', () => {
      setCookie('customCookieAccept')
    })
  }
}
